import { Badge, Skeleton, Text } from '@optiro/ui';

import { useCompanyAccountCategory } from '@/hooks/useCompanyAccountCategories/useCompanyAccountCategory';
import { CompanyAccountCategory } from '@/types/types';

type Props = {
  category?: CompanyAccountCategory;
  categoryId?: string | number;
  simple?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xs';
};

const AccountCategoryBadge = ({ category, categoryId, size = 'lg', simple = false }: Props) => {
  // If category is not provided but categoryId is, fetch it
  const { data, isLoading } = useCompanyAccountCategory(!category && categoryId ? categoryId : '');

  const cat = category || data;

  if (!cat) {
    return isLoading ? <Skeleton height={24} width={80} radius="xl" /> : null;
  }

  if (simple) {
    return (
      <Text size="xs" c="dimmed">
        {cat.name}
      </Text>
    );
  }

  return (
    <Badge size={size} color={cat.color} variant="light">
      {cat.name}
    </Badge>
  );
};

export { AccountCategoryBadge };
